export default ".body {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n.body .body-container {\n  flex: auto;\n}";